import script from "./DashboardCellAssigneedOwner.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCellAssigneedOwner.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCellAssigneedOwner.vue?vue&type=style&index=0&id=8dd883a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd883a2"]])

export default __exports__